var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7507 7.79221L10.3037 10.2637C10.9251 11.0923 11.2932 12.1215 11.2932 13.2367C11.2932 15.9797 9.06629 18.2016 6.32141 18.2016C3.57654 18.2016 1.34961 15.9797 1.34961 13.2367C1.34961 10.4937 3.57654 8.27185 6.32141 8.27185C7.48138 8.27185 8.54885 8.66864 9.39484 9.33388L16.6633 1.99293C16.9159 1.73784 17.3278 1.73546 17.5833 1.98763C17.8388 2.2398 17.8411 2.65102 17.5886 2.90612L16.7005 3.80306L18.3112 5.41125C18.7612 5.8605 18.7612 6.58965 18.3112 7.0389L15.9663 9.38015C15.5173 9.82838 14.7902 9.82838 14.3412 9.38015L12.7507 7.79221ZM13.6654 6.86841L15.1537 8.35436L17.2864 6.22508L15.7858 4.72686L13.6654 6.86841ZM6.32141 9.57185C4.29255 9.57185 2.64961 11.2137 2.64961 13.2367C2.64961 15.2598 4.29255 16.9016 6.32141 16.9016C8.35028 16.9016 9.99322 15.2598 9.99322 13.2367C9.99322 11.2137 8.35028 9.57185 6.32141 9.57185Z",
    fill: "#151F29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.74835f58fbab280d4387def93b53aa23.svg";
export { ForwardRef as ReactComponent };